import { FC } from 'react';

import { CustomModal } from '../CustomModal';
import { t } from 'i18next';
import { Box, Button, CircularProgress } from '@mui/material';
import { History } from '../History';
import { useReportHistoryModal } from './hooks';

interface ReportHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  report_id: string;
}

export const ReportHistoryModal: FC<ReportHistoryModalProps> = ({
  isOpen,
  onClose,
  report_id,
}) => {
  const {
    historyList,
    isPending,
    count,
    historyPage,
    setHistoryPage,
    handleCloseAction,
  } = useReportHistoryModal({
    report_id,
    isOpen,
    onClose,
  });

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleCloseAction}
      title={t('reporting.report.preview.viewReportHistory')}
      isLoading={isPending}
    >
      <Box>
        {isPending ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <History
            page={historyPage}
            changePage={setHistoryPage}
            history={historyList}
            count={count}
            additionalActionButton={
              <Button
                variant='contained'
                color='secondary'
                sx={{ color: theme => theme.palette.common.white }}
                onClick={handleCloseAction}
              >
                {t('general.close')}
              </Button>
            }
          />
        )}
      </Box>
    </CustomModal>
  );
};
